import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { TextButton, Text, Headline } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_50, } from '@oneaudi/unified-web-common';
import { useI18n } from '@oneaudi/i18n-context';
import { useServicesContext } from '../../../../../../context';
import { DangerousElement } from '../../../../../../components/DangerousElement';
import { FinanceCheckoutLegalLayer } from './FinanceCheckoutLegalLayer';
export const FinanceCheckoutLayer = ({ buttonInfo, trackButtonClick, isApiInprogress, closeFocusLayer, fsCheckoutLink, }) => {
    const layerManager = useServicesContext().getAdditionalService('gfa:layer-manager');
    const [focusLayerNode, setFocusLayerNode] = React.useState();
    const [focusLayer, setFocusLayer] = React.useState();
    const focusLayerRef = React.useCallback((node) => {
        setFocusLayerNode(node);
    }, [setFocusLayerNode]);
    const financeCheckoutTranslations = {
        financeCheckoutOuterLayer: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.outer.financeCheckoutLegalLayer.ariaLabel`,
        }),
        financeCheckoutInnerLayer: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.inner.financeCheckoutLegalLayer.ariaLabel`,
        }),
        popoverHeading: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.heading`,
        }),
        popoverContent: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.content`,
        }),
        financeCheckoutLayerCloseBtn: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.financeCheckoutLayerCloseBtn.ariaLabel`,
        }),
        popoverCloseButton: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.close`,
        }),
        financeCheckoutLayerContinueBtn: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.financeCheckoutLayerContinueBtn.ariaLabel`,
        }),
        popoverContinueButton: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.continue`,
        }),
        popoverLegalText: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.legalText`,
        }),
        financeCheckoutLayerReadMoreBtn: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.financeCheckoutLayerReadMoreBtn.ariaLabel`,
        }),
        popoverLegalTextLink: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.popoverLegalTextLink`,
        }),
    };
    const openFocusLayer = () => {
        const layer = layerManager.openFocusLayer(() => React.createElement("div", { ref: focusLayerRef }), {
            primaryAriaLabel: financeCheckoutTranslations.financeCheckoutOuterLayer,
            secondaryAriaLabel: financeCheckoutTranslations.financeCheckoutInnerLayer,
        }, {
            size: "A",
            userCloseable: true,
            onClose: () => {
                closeFocusLegalLayer();
            },
        });
        setFocusLayer(layer);
    };
    const closeFocusLegalLayer = () => focusLayer === null || focusLayer === void 0 ? void 0 : focusLayer.close();
    return (React.createElement(FinanceCheckoutLayerWrapper, { "data-testid": "finance-checkout-Layer" },
        React.createElement(React.Fragment, null, focusLayerNode &&
            ReactDOM.createPortal(React.createElement(FinanceCheckoutLegalLayer, { buttonInfo: buttonInfo, trackButtonClick: trackButtonClick, closeFocusLayer: closeFocusLegalLayer }), focusLayerNode)),
        React.createElement(Headline, { tag: "h2", variant: {
                order: '4',
                weight: 'bold',
                type: 'headline',
            }, margin: [0, 0, SYS_SPACE_FIXED_300, 0] }, financeCheckoutTranslations.popoverHeading),
        React.createElement(Text, { margin: [0, 0, SYS_SPACE_FIXED_300, 0], variant: {
                order: '1',
                style: 'normal',
                type: 'copy',
            } },
            React.createElement(DangerousElement, { as: "span", html: financeCheckoutTranslations.popoverContent, sanitize: false })),
        React.createElement(FSPopoverCTASectionWrap, null,
            React.createElement(StyledButton, { variant: "secondary", "aria-label": financeCheckoutTranslations.financeCheckoutLayerCloseBtn, onClick: () => {
                    trackButtonClick(Object.assign(Object.assign({}, buttonInfo), { label: financeCheckoutTranslations.popoverCloseButton, url: '' }), 'secondary', buttonInfo.trackingCode, 'cancel');
                    closeFocusLayer();
                }, margin: [0, 0, SYS_SPACE_FIXED_300, 0], isLoading: isApiInprogress, "data-testid": `${buttonInfo.type}-close` }, financeCheckoutTranslations.popoverCloseButton),
            buttonInfo.type === 'finance-checkout' && buttonInfo.method === 'POST' && (React.createElement(React.Fragment, null,
                React.createElement(StyledButton, { href: fsCheckoutLink, "aria-label": financeCheckoutTranslations.financeCheckoutLayerContinueBtn, onClick: () => trackButtonClick(Object.assign(Object.assign({}, buttonInfo), { label: financeCheckoutTranslations.popoverContinueButton, url: fsCheckoutLink }), 'tertiary', buttonInfo.trackingCode, 'continue to'), target: buttonInfo.target || '_blank', rel: "noopener", variant: "primary", margin: [0, 0, SYS_SPACE_FIXED_300, 0], "data-testid": `${buttonInfo.type}-continue`, isLoading: isApiInprogress, "data-tracking-exclude": true }, financeCheckoutTranslations.popoverContinueButton)))),
        financeCheckoutTranslations.popoverLegalText && (React.createElement(FooterLinkWrapper, null,
            React.createElement(Text, { variant: {
                    order: '1',
                    style: 'normal',
                    type: 'copy',
                }, tag: "span", margin: [SYS_SPACE_FIXED_100, 0, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_100], className: "popoverLegalTxt" }, financeCheckoutTranslations.popoverLegalText),
            React.createElement(TextButton, { id: "readmore-legal-text", variant: "tertiary", "data-testid": "readmore-legal-text", margin: [0, 0, SYS_SPACE_FIXED_100, 0], onClick: () => {
                    openFocusLayer();
                }, className: "popoverLegalBtn", "data-tracking-exclude": true, "aria-label": financeCheckoutTranslations.financeCheckoutLayerReadMoreBtn },
                React.createElement(Text, { tag: "span", variant: {
                        order: '1',
                        style: 'normal',
                        type: 'copy',
                    } }, financeCheckoutTranslations.popoverLegalTextLink))))));
};
const FinanceCheckoutLayerWrapper = styled.div `
  padding: ${SYS_SPACE_FIXED_50} 0 ${SYS_SPACE_FIXED_50} 0;
`;
const FSPopoverCTASectionWrap = styled.div `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  min-height: 55px;
  gap: ${SYS_SPACE_FIXED_100};
  @media (max-width: 479px) {
    flex-direction: column;
    gap: 0px;
  }
`;
const StyledButton = styled((props) => React.createElement(TextButton, Object.assign({}, props))) `
  @media (max-width: 479px) {
    width: 100%;
  }
`;
const FooterLinkWrapper = styled.div `
  margin: 0;
  display: flex;
  align-items: center;

  .popoverLegalTxt {
    margin: 0px;
  }
  .popoverLegalBtn {
    margin-bottom: 0px;
    margin-left: ${SYS_SPACE_FIXED_50};
    padding: 0px;
    text-decoration: underline;
  }
  @media (max-width: 479px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
